import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=0447c90e"
import script from "./PromoCodes.ts?vue&type=script&lang=ts&external"
export * from "./PromoCodes.ts?vue&type=script&lang=ts&external"
import style0 from "./PromoCodes.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports